import { ArdoqId } from '@ardoq/api-types';
import { persistentReducedStream, reducer } from '@ardoq/rxbeach';
import {
  markWorkspaceAggregatedLoaded,
  markWorkspaceAggregatedUnloaded,
} from './actions';

type AggregatedLoadedState = {
  loadedWorkspaceIds: Set<ArdoqId>;
};

const initialState: AggregatedLoadedState = {
  loadedWorkspaceIds: new Set(),
};

const markLoaded = (
  state: AggregatedLoadedState,
  { workspaceId }: { workspaceId: ArdoqId }
): AggregatedLoadedState => ({
  loadedWorkspaceIds: new Set([...state.loadedWorkspaceIds, workspaceId]),
});

const markUnloaded = (
  state: AggregatedLoadedState,
  { workspaceId }: { workspaceId: ArdoqId }
): AggregatedLoadedState => {
  const newSet = new Set(state.loadedWorkspaceIds);
  newSet.delete(workspaceId);
  return {
    loadedWorkspaceIds: newSet,
  };
};

const handleMarkWorkspaceLoaded = reducer(
  markWorkspaceAggregatedLoaded,
  markLoaded
);

const handleMarkWorkspaceUnloaded = reducer(
  markWorkspaceAggregatedUnloaded,
  markUnloaded
);

const reducers = [handleMarkWorkspaceLoaded, handleMarkWorkspaceUnloaded];

export const aggregatedLoaded$ = persistentReducedStream(
  'aggregatedLoaded$',
  initialState,
  reducers
);

export const isWorkspaceCurrentlyLoaded = (workspaceId: ArdoqId): boolean => {
  return aggregatedLoaded$.state.loadedWorkspaceIds.has(workspaceId);
};
